// js to wrap the image collapse and rich text section
document.addEventListener("DOMContentLoaded", () => {
  const collapseSections = document.querySelectorAll(".collapse_tabs_section");

  collapseSections.forEach((section) => {
    const parentSection = section.closest(".shopify-section");
    if (!parentSection) return;

    let nextSection = parentSection.nextElementSibling;

    if (!nextSection) return;

    const richText = nextSection.querySelector(".richtext__section");

    if (richText) {
      if (
        parentSection.parentNode.classList.contains("combined-sections-wrapper")
      )
        return;

      const wrapper = document.createElement("div");
      wrapper.className = "combined-sections-wrapper page-width";

      // Insert wrapper before first section
      parentSection.parentNode.insertBefore(wrapper, parentSection);

      wrapper.appendChild(parentSection);
      wrapper.appendChild(nextSection);
    }
  });
});
// ends
